import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import animations from 'src/styles/animations';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, animations.pulse), helpers), {}, {
  avatar: {
    backgroundColor: palette.info.main,
    border: '1px solid',
    borderRadius: '50%',
    height: '32px',
    color: palette.common.white,
    fontSize: '13px',
    fontFamily: palette.fontFamilies.poppins,
    fontWeight: '600',
    flexShrink: '0',
    lineHeight: '32px',
    marginRight: '-10px',
    textAlign: 'center',
    width: '32px'
  },
  avatarAddPlusBlock: {
    backgroundColor: palette.shades[200],
    color: palette.shades[700],
    borderColor: palette.shades[100],
    cursor: 'default'
  },
  avatarsBlock: {
    alignItems: 'center',
    display: 'flex',
    marginLeft: '12px'
  },
  flexBox: {
    display: 'flex',
    alignItems: 'center'
  },
  grid: {
    '& .MuiDataGrid-row:has(.finallBill) .MuiDataGrid-cell ': {
      padding: '8px 5px 32px 5px'
    },
    '& .MuiDataGrid-columnHeader:first-child': {
      '&:hover .MuiDataGrid-columnHeaderDraggableContainer': {
        backgroundColor: 'transparent'
      },
      '& button': {
        display: 'none'
      }
    },
    '& .MuiDataGrid-cell:first-of-type': {
      paddingLeft: '10px'
    },
    '& .MuiDataGrid-columnHeader:nth-of-type(1)': {
      paddingLeft: '17px'
    },
    '& .MuiDataGrid-columnHeader:last-child': {
      paddingRight: '10px',
      '& .MuiButton-root': {
        margin: 0
      }
    },
    '& .MuiDataGrid-cell:last-of-type': {
      paddingRight: '12px'
    },
    '& .MuiChip-root': {
      fontWeight: '600'
    }
  },
  tableContainer: {
    width: '100%',
    overflow: 'scroll',
    height: 'calc(82vh - 148px)'
  },
  multiselectEnabled: {
    height: 'calc(82vh - 240px)'
  },
  rippleContainer: {
    width: '100%'
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  disabledCell: {
    backgroundColor: palette.shades[200],
    '& .MuiButton-root': {
      backgroundColor: palette.shades[200],
      borderColor: palette.shades[300]
    }
  },
  disabledCellText: {
    color: palette.shades[500],
    padding: '10px 6px'
  },
  tooltipContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  rightAlign: {
    textAlign: 'right'
  },
  accessWrapper: {
    padding: '4px !important',
    width: 'auto !important'
  },
  statusInfo: {
    display: 'flex'
  },
  cellLeftAlign: {
    justifyContent: 'flex-start !important'
  },
  cellContent: {
    borderRadius: '2px',
    transition: "all ".concat(palette.transitions.short),
    width: '100%',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: palette.shades[300],
      cursor: 'pointer'
    }
  },
  toolboxWrapperHeader: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      marginLeft: '10px'
    }
  },
  utilitiesTooltipItem: {
    display: 'flex',
    paddingBottom: '4px',
    '& .MuiTypography-root': {
      width: '10rem'
    }
  },
  autoBillingStatus: {
    '& .MuiSvgIcon-root': {
      fontSize: '24px'
    }
  }
}));
export default useStyles;